import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary, $textSecondary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import SmartLink from '../../../SmartLink'
import styles from './styles.module.css'

function Step3() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">03</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>You become a creator</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Upon selection, you will enter into a dynamic 6-month partnership with VRS. This period is structured to provide continuous support and collaboration, helping you maximize your creative potential and reach within the sim racing community.</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textPrimary.dark}>This partnership is your opportunity to elevate your profile, engage with a wider audience, and become a recognized figure in the sim racing community. Embrace the chance to grow, innovate, and lead in the thrilling world of sim racing.</Text>
          <Spacer size={16}/>
          <SmartLink href={'/contact'} className={styles.textLink}>
            <Text type="large" color={$textSecondary.dark}>Preview of the contract</Text>
          </SmartLink>
        </div>
      </div>
    </div>
  )
}

export default Step3
